import * as Scrivito from "scrivito";
import PageHeadBlock from "^/Components/StoriesPreview/PageHeadBlock";

import setLanguage from "^/utils/setLanguage";

const GlobalNewsOverviewPage = ({ page }) => {
  setLanguage(page);

  return (
    <>
      <PageHeadBlock page={page} />

      <Scrivito.ContentTag
        tag="div"
        content={page}
        attribute="body"
        className="mt-5"
      />
    </>
  );
};
Scrivito.provideComponent("GlobalNewsOverviewPage", GlobalNewsOverviewPage);
